// Typed wrapper around the untyped '@engage_so/js' package.
// This avoids TS errors and adds type safety.

export interface EngageInitOptions {
  key: string;
}

export interface IdentifyOptions {
  id: string | number;
  email?: string;
  first_name?: string;
  last_name?: string;
  created_at?: string | Date;
  [key: string]: any;
}

export interface TrackEvent {
  event: string;
  properties?: Record<string, any>;
}

export interface EngageAPI {
  init(options: EngageInitOptions): void;
  identify(options: IdentifyOptions): void;
  addAttribute(id: string | number, attributes: Record<string, any>): void;
  track(id: string | number, event: string | TrackEvent): void;
  merge(sourceId: string | number, destinationId: string | number): void;
}

const runtime: any = require("@engage_so/js");

const Engage: EngageAPI = runtime;

let isInitialized = false;
export function initializeEngage(publicKey: string) {
  if (typeof window === "undefined" || isInitialized || !publicKey) return;
  isInitialized = true;
  Engage.init({ key: publicKey });
}

export default Engage;
